import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import $ from 'jquery';
import {
	Button,
	ButtonGroup,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';

class StudentPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: new Array(2).fill(false),
			dropdownOpen1: new Array(2).fill(false),
			dropdownOpen2: new Array(2).fill(false),
			dropdownOpen3: new Array(2).fill(false),
		}
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.toggle3 = this.toggle3.bind(this);
	}

	toggle(i) {
		const newArray = this.state.dropdownOpen.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen: newArray
		});
	}
	toggle1(i) {
		const newArray = this.state.dropdownOpen1.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen1: newArray
		});
	}
	toggle2(i) {
		const newArray = this.state.dropdownOpen2.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen2: newArray
		});
	}

	toggle3(i) {
		const newArray = this.state.dropdownOpen3.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen3: newArray
		});
	}

	render() {

		let userData = JSON.parse(sessionStorage.getItem('userData'));
		this.state.userRole = userData['userrole'];
	
		return (
			<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
				<a className="navbar-brand" href="javascript:;"><i className="fa fa-user"></i>&nbsp; Student</a>
				{/*<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>*/}
				<div className="">
					{this.state.userRole == 'classteacher' ?
						<ul className="navbar-nav mr-auto">
							<li className="nav-item active">
								<ButtonDropdown isOpen={this.state.dropdownOpen3[0]} toggle={() => { this.toggle3(0); }}>
									<DropdownToggle caret color="report">
										Attendance
								</DropdownToggle>
									<DropdownMenu>
										<Link to="/student/attendancenew" className="dropdown-item" >Add Attendance</Link>
										<Link to="/student/attendanceedit" className="dropdown-item" >Edit Attendance</Link>
										<Link to="/student/attendanceview" className="dropdown-item" >View Attendance</Link>

									</DropdownMenu>
								</ButtonDropdown>
							</li>
						</ul>
					:
					<ul className="navbar-nav mr-auto">
						<li className="nav-item active">
							<Link to="/student/dashboard" className="nav-link" >Dashboard</Link>
						</li>
						<li className="nav-item dropdown">
							<ButtonDropdown isOpen={this.state.dropdownOpen1[0]} toggle={() => { this.toggle1(0); }}>
								<DropdownToggle caret color="settings">
									Settings
				</DropdownToggle>
								<DropdownMenu>
									<Link to="/student/category" className="dropdown-item" >Category</Link>
									<Link to="/settings/caste" className="dropdown-item">Caste & Religion</Link>
								</DropdownMenu>
							</ButtonDropdown>
						</li>
						<li className="nav-item active">
							<Link to="/student/admission" className="nav-link" >Admission</Link>
						</li>
						<li className="nav-item active">
							<Link to="/student/list" className="nav-link" >List</Link>
						</li>
						<li className="nav-item dropdown">
							<ButtonDropdown isOpen={this.state.dropdownOpen[0]} toggle={() => { this.toggle(0); }}>
								<DropdownToggle caret color="upload">
									Upload
				</DropdownToggle>
								<DropdownMenu>
									<Link to="/student/photoupload" className="dropdown-item" >Photo</Link>
									<Link to="/student/mobileupload" className="dropdown-item">Mobile Number</Link>
								</DropdownMenu>
							</ButtonDropdown>
						</li>
						<li className="nav-item dropdown">
							<ButtonDropdown isOpen={this.state.dropdownOpen2[0]} toggle={() => { this.toggle2(0); }}>
								<DropdownToggle caret color="report">
									Report
				</DropdownToggle>
								<DropdownMenu>
									<Link to="/student/report" className="dropdown-item" >Overall Report</Link>
									<Link to="/student/customreport" className="dropdown-item">Custom Report</Link>
								</DropdownMenu>
							</ButtonDropdown>
						</li>
						<li className="nav-item active">
							<Link to="/student/leaverequests" className="nav-link" >Leave Request</Link>
						</li>
						<li className="nav-item active">
							<ButtonDropdown isOpen={this.state.dropdownOpen3[0]} toggle={() => { this.toggle3(0); }}>
								<DropdownToggle caret color="report">
									Attendance
							</DropdownToggle>
								<DropdownMenu>
									<Link to="/student/attendancenew" className="dropdown-item" >Add Attendance</Link>
									<Link to="/student/attendanceedit" className="dropdown-item" >Edit Attendance</Link>
									<Link to="/student/attendanceview" className="dropdown-item" >View Attendance</Link>

								</DropdownMenu>
							</ButtonDropdown>
						</li>
						<li className="nav-item active">
							<Link to="/promote" className="nav-link" >Promotion</Link>
						</li>
						<li className="nav-item active">
							<Link to="/student/transport" className="nav-link" >Transport Students</Link>
						</li>
					</ul> }
				</div>
			</nav>
		)
	}
}

export default StudentPage;


// WEBPACK FOOTER //
// ./src/views/StudentPage/StudentPage.js